import { useEffect, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "primereact/button";
import { IPurchaseOrder, POStatus } from "../../../models/PurchaseOrder";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { JVInput } from "../../../shared/JVInput";
import { JVDropdown } from "../../../shared/JVDropdown";
import { IRolesDropdown, IUsersDropdown } from "../../../models/IDropdown";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { ILogin } from "../../../models/Login";

interface IIncentiveCalc {
    incentive_ID?: number,
    pO_ID?: number,
    userID?: number,
    role_ID?: number,
    userName?: string,
    role_Name?: string,
    incPer?: number,
    createdBy?: number,
    incetive_Added_On?: Date,
    is_Verify?: boolean
}

interface Iprops {
    po: IPurchaseOrder,
    toast: any,
    activeIndex: number,
    setActiveIndex: (index: number) => void,
    setNeedtoReload: (reload: boolean) => void
}

const schema = yup.object({
    userID: yup.number().min(1, "Name is required").required("Name is required"),
    role_ID: yup.number().min(1, "Role is required").required("Name is required"),
    incPer: yup.number().positive("% is required").required("% is required")
});

export const IncentiveCalculation = (props: Iprops) => {
    const [loading, setLoading] = useState(false);
    const [roles, setRoles] = useState<Array<IRolesDropdown>>();
    const [users, setUsers] = useState<Array<IUsersDropdown>>();
    const [list, setList] = useState<Array<IIncentiveCalc>>([]);
    const [deleteForm, setDeleteForm] = useState({ open: false, data: {} } as { open: boolean, data: IIncentiveCalc });
    const [categoryPercentages, setCategoryPercentages] = useState<any>(null);
    const [isTeamRole, setIsTeamRole] = useState<number>(0);

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const { control, handleSubmit, formState: { errors }, reset, watch, setError, clearErrors } = useForm<IIncentiveCalc>({
        resolver: yupResolver(schema),
        defaultValues: { userID: 0, role_ID: 0, incPer: 0 },
        shouldFocusError: false
    });

    const loadRoles = async () => {
        const response = await Fetch("Dropdown/roles", "GET", null, null, null);
        if (response) {
            const data: Array<IRolesDropdown> = await response.json();
            const _data: Array<IRolesDropdown> = [];
            data.forEach(d => {
                _data.push({ role_ID: d.role_ID, role_Name: d.role_Name });
            })
            setRoles(_data);
        }
    }
    const loadUsers = async (roleID: number) => {
        const response = await Fetch("Dropdown/getUsersByRoleID", "GET", null, `role_id=${roleID}`, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            setUsers(data);
        }
    }

    const getPercentagesByCategory = async (category: number) => {
        const response = await Fetch("Dropdown/getPercentageList", "GET", null, `category=${category}`, null);
        if (response) {
            const data: any = await response.json();
            console.log(data);
            setCategoryPercentages(data);
        }
    };

    useEffect(() => {
        getPercentagesByCategory(props.po.req_Category || 0);
        loadUsers(0);
        loadRoles();
        loadList();
    }, []);

    const saveToDB = async (body: IIncentiveCalc) => {
        if (!(_roles.includes(1) || _roles.includes(26)) && props?.po?.pO_Status === POStatus.Joined) {
            props.toast.current.show({ severity: 'error', detail: "Incentive Calculation Hierarchy can not be updated on PO Status : Joined", life: 3000 });
        } else {
            setLoading(true);
            const method = (body.incentive_ID != null && body.incentive_ID != undefined && body.incentive_ID) ? "PUT" : "POST";
            const message = (body.incentive_ID != null && body.incentive_ID != undefined && body.incentive_ID) ? "Updated Successfully" : "Added Successfully";
            body.pO_ID = props.po.pO_ID;
            const response = await Fetch("vwPODetails/incentive", method, body, null, props.toast);
            if (response) {
                props.toast.current.show({ severity: 'success', content: message });
                reset({ userID: 0, role_ID: 0, incPer: 0 });
                loadList();
            } else setLoading(false);
        }
    }

    const deleteFromDB = async (incentive_ID: number) => {
        if (!(_roles.includes(1) || _roles.includes(26)) && props?.po?.pO_Status === POStatus.Joined) {
            props.toast.current.show({ severity: 'error', detail: "Incentive Calculation Hierarchy can not be updated on PO Status : Joined", life: 3000 });
        } else {
            setLoading(true);
            const response = await Fetch("vwPODetails/incentive", "DELETE", null, `incentive_ID=${incentive_ID}`, props.toast);
            if (response) {
                props.toast.current.show({ severity: 'success', content: "Deleted Successfully" });
                reset({ userID: 0, role_ID: 0, incPer: 0 });
                loadList();
                setDeleteForm(prev => prev = { open: false, data: {} });
            } else setLoading(false);
        }
    }

    function onSubmit(data: IIncentiveCalc) {
        if (data.role_ID != null && data.role_ID != 0 && data.role_ID === 2 && categoryPercentages != null && categoryPercentages?.sales_Manager_MaxPer != null && (data.incPer || 0) > categoryPercentages?.sales_Manager_MaxPer) {
            props.toast.current.show({ severity: 'error', detail: `Percentage must be less or equal to ${categoryPercentages?.sales_Manager_MaxPer}`, life: 3000 });
        } else if (data.role_ID != null && data.role_ID != 0 && data.role_ID === 3 && categoryPercentages != null && categoryPercentages?.normal_Recruiter_MaxPer != null && (data.incPer || 0) > categoryPercentages?.normal_Recruiter_MaxPer) {
            props.toast.current.show({ severity: 'error', detail: `Percentage must be less or equal to ${categoryPercentages?.normal_Recruiter_MaxPer}`, life: 3000 });
        } else if (data.role_ID != null && data.role_ID != 0 && data.role_ID === 4 && categoryPercentages != null && categoryPercentages?.recruitment_Head_MaxPer != null && (data.incPer || 0) > categoryPercentages?.recruitment_Head_MaxPer) {
            props.toast.current.show({ severity: 'error', detail: `Percentage must be less or equal to ${categoryPercentages?.recruitment_Head_MaxPer}`, life: 3000 });
        } else if (data.role_ID != null && data.role_ID != 0 && data.role_ID === 5 && categoryPercentages != null && categoryPercentages?.sales_Head_MaxPer != null && (data.incPer || 0) > categoryPercentages?.sales_Head_MaxPer) {
            props.toast.current.show({ severity: 'error', detail: `Percentage must be less or equal to ${categoryPercentages?.sales_Head_MaxPer}`, life: 3000 });
        } else if (data.role_ID != null && data.role_ID != 0 && data.role_ID === 6 && categoryPercentages != null && (isTeamRole === 2 ? categoryPercentages?.sales_Team_Lead_MaxPer != null : categoryPercentages?.recruiter_Team_Lead_MaxPer != null) && (data.incPer || 0) > (isTeamRole === 2 ? categoryPercentages.sales_Team_Lead_MaxPer : categoryPercentages.recruiter_Team_Lead_MaxPer)) {
            props.toast.current.show({ severity: 'error', detail: `Percentage must be less or equal to ${isTeamRole === 2 ? categoryPercentages?.sales_Team_Lead_MaxPer : categoryPercentages?.recruiter_Team_Lead_MaxPer}`, life: 3000 });
        } else if (data.role_ID != null && data.role_ID != 0 && data.role_ID === 28 && categoryPercentages != null && (isTeamRole === 2 ? categoryPercentages?.sales_Resource_Manager_MaxPer != null : categoryPercentages?.recruiter_Resource_Manager_MaxPer != null) && (data.incPer || 0) > (isTeamRole === 2 ? categoryPercentages.sales_Resource_Manager_MaxPer : categoryPercentages.recruiter_Resource_Manager_MaxPer)) {
            props.toast.current.show({ severity: 'error', detail: `Percentage must be less or equal to ${isTeamRole === 2 ? categoryPercentages?.sales_Resource_Manager_MaxPer : categoryPercentages?.recruiter_Resource_Manager_MaxPer}`, life: 3000 });
        } else {
            const user = users?.find(user => user.login_ID === data.userID);
            data.userName = user?.user_Name;
            const role = roles?.find(role => role.role_ID === data.role_ID);
            data.role_Name = role?.role_Name;
            saveToDB(data);
            //props.setActiveIndex(props.activeIndex + 1);
            props.setNeedtoReload(true);
        }
    }

    const loadList = async () => {
        setLoading(true);
        const response = await Fetch("vwPODetails/incentive", "GET", null, `po_id=${props.po.pO_ID}`, props.toast);
        if (response) {
            const data: Array<IIncentiveCalc> = await response.json();
            setList(data);
        }
        setLoading(false);
    }

    const actionBodyTemplate = (rowData: IIncentiveCalc) => {
        return (
            <div className="flex">
                <Button icon="pi pi-pencil" label="Edit" className="p-button-rounded p-button-text p-button-primary" onClick={() => { if (rowData.incentive_ID) reset(rowData) }} />
                <Button icon="pi pi-trash" label="Delete" className="p-button-rounded p-button-text p-button-danger" onClick={() => { if (rowData.incentive_ID) setDeleteForm(prev => prev = { open: true, data: rowData }) }} />
            </div>
        );
    };

    const dFooter = () => {
        return (<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '5px' }}>
            <Button loading={loading} className="p-button-sm my-1 p-button-danger" label="REMOVE" onClick={() => { deleteFromDB(deleteForm?.data?.incentive_ID || 0) }} type="button"></Button>
            <Button className="p-button-sm p-button-outlined my-1" label="CLOSE" onClick={() => { setDeleteForm(prev => prev = { open: false, data: {} }) }} type="button"></Button>
        </div>);
    };

    const verifyRow = (rowData: IIncentiveCalc) => {
        //<Button icon="pi pi-trash" label="Delete" className="p-button-rounded p-button-text p-button-danger" onClick={() => { if (rowData.incentive_ID) setDeleteForm(prev => prev = { open: true, data: rowData }) }} />
        return (
            <>
                <Checkbox checked={rowData.is_Verify === true ? true : false} onChange={() => {
                    rowData.is_Verify = rowData.is_Verify === true ? false : true;
                    // console.log(rowData);
                    saveToDB(rowData);
                }} />
            </>
        );
    };

    const rowClass = (data: any) => {

        return {
            'bg-green-100 ': data.is_Verify === true,
            'bg-pink-100 ': data.is_Verify !== true,
            //            'bg-orange-100 font-semibold': data.reqType_ID===1 ,

        };
    };

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "incPer") {
                if (value.incPer != null && value.incPer != 0) {
                    if (control._formValues.role_ID != null && control._formValues.role_ID != 0 && control._formValues.role_ID === 2 && categoryPercentages != null && categoryPercentages?.sales_Manager_MaxPer != null && value.incPer > categoryPercentages?.sales_Manager_MaxPer) {
                        setError("incPer", { message: `Percentage must be less or equal to ${categoryPercentages?.sales_Manager_MaxPer}` }, { shouldFocus: true });
                    } else if (control._formValues.role_ID != null && control._formValues.role_ID != 0 && control._formValues.role_ID === 3 && categoryPercentages != null && categoryPercentages?.normal_Recruiter_MaxPer != null && value.incPer > categoryPercentages?.normal_Recruiter_MaxPer) {
                        setError("incPer", { message: `Percentage must be less or equal to ${categoryPercentages?.normal_Recruiter_MaxPer}` }, { shouldFocus: true });
                    } else if (control._formValues.role_ID != null && control._formValues.role_ID != 0 && control._formValues.role_ID === 4 && categoryPercentages != null && categoryPercentages?.recruitment_Head_MaxPer != null && value.incPer > categoryPercentages?.recruitment_Head_MaxPer) {
                        setError("incPer", { message: `Percentage must be less or equal to ${categoryPercentages?.recruitment_Head_MaxPer}` }, { shouldFocus: true });
                    } else if (control._formValues.role_ID != null && control._formValues.role_ID != 0 && control._formValues.role_ID === 5 && categoryPercentages != null && categoryPercentages?.sales_Head_MaxPer != null && value.incPer > categoryPercentages?.sales_Head_MaxPer) {
                        setError("incPer", { message: `Percentage must be less or equal to ${categoryPercentages?.sales_Head_MaxPer}` }, { shouldFocus: true });
                    } else if (control._formValues.role_ID != null && control._formValues.role_ID != 0 && control._formValues.role_ID === 6 && categoryPercentages != null && (isTeamRole === 2 ? categoryPercentages?.sales_Team_Lead_MaxPer != null : categoryPercentages?.recruiter_Team_Lead_MaxPer != null) && value.incPer > (isTeamRole === 2 ? categoryPercentages?.sales_Team_Lead_MaxPer : categoryPercentages?.recruiter_Team_Lead_MaxPer)) {
                        setError("incPer", { message: `Percentage must be less or equal to ${isTeamRole === 2 ? categoryPercentages?.sales_Team_Lead_MaxPer : categoryPercentages?.recruiter_Team_Lead_MaxPer}` }, { shouldFocus: true });
                    } else if (control._formValues.role_ID != null && control._formValues.role_ID != 0 && control._formValues.role_ID === 28 && categoryPercentages != null && (isTeamRole === 2 ? categoryPercentages?.sales_Resource_Manager_MaxPer != null : categoryPercentages?.recruiter_Resource_Manager_MaxPer != null) && value.incPer > (isTeamRole === 2 ? categoryPercentages?.sales_Resource_Manager_MaxPer : categoryPercentages?.recruiter_Resource_Manager_MaxPer)) {
                        setError("incPer", { message: `Percentage must be less or equal to ${categoryPercentages?.sales_Resource_Manager_MaxPer}` }, { shouldFocus: true });
                    } else {
                        clearErrors("incPer");
                    }
                }
            }
            if (name === "role_ID") {
                if (value.role_ID != null && value.role_ID != 0) {
                    loadUsers(value.role_ID);
                }
            }
            if (name === "userID") {
                if (value.userID != null && value.userID != 0 && (control._formValues.role_ID === 6 || control._formValues.role_ID === 28)) {
                    let userNmae = users?.filter(user => user.login_ID === value.userID) || [];
                    if (userNmae[0].user_Name?.includes("Sales")) {
                        setIsTeamRole(2);
                    } else if (userNmae[0].user_Name?.includes("Recruiter")) {
                        setIsTeamRole(3);
                    }
                }
            }
        });
        return () => subscription.unsubscribe();

    }, [watch, categoryPercentages, users, isTeamRole]);

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mt-3">
                <JVDropdown required column={4} label="Role" control={control} name="role_ID" options={roles} optionLabel="role_Name" optionValue="role_ID" placeholder="Select Role" error={errors.role_ID?.message} />
                <JVDropdown required column={4} label="Name" filter={true} control={control} name="userID" options={users} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Name" error={errors.userID?.message} />
                <JVInput required column={4} label="%" control={control} name="incPer" error={errors.incPer?.message} />
                <div className="field col-12 md:col-3">
                    <label htmlFor="">&nbsp;</label>
                    <Button loading={loading} type="submit" label="Add Inc"></Button>
                </div>
            </form>
            <DataTable className="mt-2" style={{ border: '1px solid rgba(105,105,105,0.5)', borderTopWidth: "0" }}
                rowClassName={rowClass}
                size="small" value={list} showGridlines stripedRows loading={loading}
            >
                <Column field="userName" header="Name" />
                <Column field="role_Name" header="Role" />
                <Column field="incPer" header="Per" />
                <Column field="is_Verify" header="Verify" body={(rowData: any) => verifyRow(rowData)} />
                <Column body={actionBodyTemplate} header="Action" headerStyle={{ width: '17%' }} />
            </DataTable>
            <Dialog visible={deleteForm.open} style={{ width: '80vw' }} header="Remove Share" footer={dFooter} className="p-fluid" onHide={() => { setDeleteForm(prev => prev = { open: false, data: {} }) }}>
                <h4 className="w-full text-center">Are You Sure You Want To Remove</h4>
            </Dialog>
        </>
    );
}